<template>
  <div class="connector-root" v-loader.opacity.tab="loading">
    <div class="connector-view-switch" v-if="!isEdit">
      <button type="button" class="switch-btn" :class="{active: view === 'catalog'}" @click="setView('catalog')">
        {{ $t('connector.partners') }}
      </button>
      <button type="button" class="switch-btn" :class="{active: view === 'monitor'}" @click="setView('monitor')">
        {{ $t('connector.monitor') }}
      </button>
    </div>

    <ClinicConnectorMonitor v-if="view === 'monitor'" :clinic_uuid="clinic_uuid"/>

    <template v-else>
      <div class="clinic-connector-list" id="connector-list" v-if="!isEdit">
        <BaseTable class="no-border" v-if="tablePartners" :tabledata="tablePartners" @item-opened="toDetails">
          <template v-slot:column_partner="{item}">
            <span class="partner-cell">
              <i class="fa fa-plug"></i>
              <span class="partner-name">{{ item.label }}</span>
            </span>
          </template>
          <template v-slot:column_status="{item}">
            <span class="status-pill" :class="statusClass(item)">{{ statusLabel(item) }}</span>
          </template>
        </BaseTable>
      </div>

      <div class="clinic-edit-box" v-else>
        <ClinicConnectorEdit
          :clinic_id="clinic_id"
          :partner="selectedPartner"
          @cancel-edit="cancelEdit"
          @saved="onSaved"/>
      </div>
    </template>
  </div>
</template>

<style lang="scss" scoped>
.connector-view-switch {
  display:                         inline-flex;
  gap:                             4px;
  margin:                          6px 10px 14px;
  padding:                         4px;
  border:                          1px solid var(--Shades-30-Border);
  border-radius:                   99px;
  background:                      var(--Shades-10);

  .switch-btn {
    background:                    transparent;
    border:                        none;
    color:                         var(--Shades-60-W);
    padding:                       7px 18px;
    border-radius:                 99px;
    font-size:                     12px;
    font-weight:                   500;
    letter-spacing:                1.8px;
    text-transform:                uppercase;
    cursor:                        pointer;
    transition:                    all 0.15s ease;

    &:hover:not(.active) {
      color:                       var(--Brand-Primary);
    }

    &.active {
      background:                  var(--Brand-Secondary, #3CB391);
      color:                       var(--Shades-W, #FFF);
    }
  }
}

.partner-cell {
  display:                         inline-flex;
  align-items:                     center;
  gap:                             10px;

  i {
    color:                         var(--Brand-Secondary, #3CB391);
    font-size:                     14px;
  }

  .partner-name {
    color:                         var(--Brand-Primary);
    font-weight:                   600;
  }
}

.status-pill {
  display:                         inline-block;
  font-size:                       11px;
  font-weight:                     600;
  letter-spacing:                  0.8px;
  text-transform:                  uppercase;
  padding:                         4px 12px;
  border-radius:                   10px;

  &.connected {
    background:                    var(--Brand-Secondary, #3CB391);
    color:                         #FFF;
  }

  &.disabled {
    background:                    var(--Complementary-Yellow, #F3CD90);
    color:                         #232323;
  }

  &.unconfigured {
    background:                    var(--Shades-20);
    color:                         var(--Shades-60-W);
  }
}

.clinic-connector-list {
  padding:                         0 10px 10px 10px;
}

@media (min-width: 992px) {
  .connector-root,
  .clinic-connector-list,
  .clinic-edit-box {
    display:                       flex;
    flex-direction:                column;
    flex:                          1;
    min-height:                    0;
  }
}

@media (max-width: 991px) {
  .clinic-connector-list {
    height:                        calc(100dvh - 258px);
    max-height:                    calc(100dvh - 258px);
    padding:                       0;
  }
}

@media screen and (min-width: 992px) and (max-width: 1365px) {
  .clinic-connector-list {
    height:                        calc(100dvh - 303px);
  }
}
</style>

<script src="./ClinicConnectorsTab.js"></script>
